<template lang="pug">
  component.list(:is="tagName")
    li.list__item(v-for="el in elements" :class="el.class" v-html="el.text")
</template>

<script>
export default {
  props: {
    tagName: {
      type: String,
      default: `ol`
    },
    elements: Array
  }
}
</script>

<style lang="scss">
  .list {
    counter-reset: list;
    display: flex;
    flex-direction: column;
  }

  .list__item {
    position: relative;
    padding-top: 1.75rem;
    padding-bottom: 2rem;
    padding-left: 3.875rem;
    font-size: 1rem;
    border-top: 1px solid #f0f0f0;

    &:last-of-type {
      border-bottom: 1px solid #f0f0f0;
    }

    &::before {
      @include font('m');
      content: '0' counter(list) '.';
      counter-increment: list;
      position: absolute;
      left: 0;
      font-size: 0.9375rem;
      color: $black;
    }

    &:nth-of-type(n + 10) {
      &::before {
        content: counter(list) '.';
      }
    }
  }
</style>
